<template>
  <div class="am-finance-contract-error">
    <div class="am-header am-main-top-box">
      <span class="am-title am-main-top-box-title"><strong>Finance Contract Error</strong></span>
    </div>
    <p class="am-finance-contract-error-content">Contract Request Failed.
      Please contact Premium Finance Company directly.</p>
    <div class="am-blue-border"></div>
    <div class="am-buttons">
      <button type="button" class="btn btn-primary btn-xs" title="Close" @click="closeModal">Ok</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "FinanceContractError",
    methods: {
      closeModal() {
        this.$store.dispatch('events/fireEvent', { name: 'close-contract-error', data: null})
      }
    }
  }
</script>

<style scoped>
  .am-finance-contract-error {
    width: 450px;
    background-color: whitesmoke;
    overflow: hidden;
  }

  .am-finance-contract-error-content {
    padding: 15px;
  }

  .am-header {
    height: 35px;
  }

  .am-title {
    font-size: 14px;
    font-weight: bold;
    float: left;
    padding: 8px 8px 8px 15px;
  }

  .am-buttons {
    bottom: 0;
    padding: 9px 7px 10px 0px;
    float: right;
  }

  .am-buttons button {
    margin: 0px 2px 0px 0px;
    padding: 0px 12px 0px 12px;
  }

  .am-blue-border {
    display: block;
    width: 100%;
    border-top: 1px solid #4297d7;
    margin-top: 10px;
  }

</style>
